/**
 * This utils remove received element from array if it already include or add
 * it in another case.
 *
 * toggleArrayItem(1, [1, 2, 3, 4]) -> [2, 3, 4]
 * toggleArrayItem(5, [1, 2, 3, 4]) -> [1, 2, 3, 4, 5]
 */
export const toggleArrayItem = <T>(id: T, arr: T[]): T[] => {
  let newArr = [...arr];

  if (newArr.includes(id)) {
    const index = arr.indexOf(id);
    if (index > -1) {
      newArr.splice(index, 1);
    }
  } else {
    newArr = [id, ...arr];
  }

  return newArr;
};
